export async function generateIdempotencyKey(...params: string[]): Promise<string> {
  if (params.length === 0) {
    throw new Error('At least one parameter is required');
  }

  const input = params.join('|');

  if (typeof crypto !== 'undefined' && crypto.subtle) {
    return sha256(input);
  }

  return fnv1a64(input);
}

async function sha256(data: string): Promise<string> {
  const encoded = new TextEncoder().encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);

  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

// Fallback para contextos não-seguros (HTTP). FNV-1a 64-bit via dois uint32.
function fnv1a64(str: string): string {
  let hi = 0x84222325;
  let lo = 0xcbf29ce4;

  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);

    if (c < 0x80) {
      lo ^= c;
    } else if (c < 0x800) {
      lo ^= (c >> 6) | 0xc0;
      lo ^= (c & 0x3f) | 0x80;
    } else {
      lo ^= (c >> 12) | 0xe0;
      lo ^= ((c >> 6) & 0x3f) | 0x80;
      lo ^= (c & 0x3f) | 0x80;
    }

    const loMul = Math.imul(lo, 0x00000193);
    const hiMul = Math.imul(hi, 0x00000193) + Math.imul(lo >>> 16, 0x0193);
    lo = loMul >>> 0;
    hi = (hiMul + (loMul >>> 16)) >>> 0;
  }

  return (hi >>> 0).toString(16).padStart(8, '0') +
         (lo >>> 0).toString(16).padStart(8, '0');
}
